<template>
  <div
    class="col-span-full items-center p-1 text-xs whitespace-nowrap text-slate-500 select-none"
  >
    <slot />
  </div>
</template>
